import WeatherHome from './WeatherHome';
import React, { useRef } from "react";
import { useState, useEffect } from 'react';
import { getConfig } from './config';
import { useParams } from 'react-router-dom';

function App() {
  const [weather, setWeather] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const { buildKey } = useParams();
  const firstRun = useRef(true);

  const {weatherApi} = getConfig();

  useEffect(() => {
    if(firstRun){
      fetchWeather();
      firstRun.current = false;
    }
  },[]);

  const fetchWeather = async () => {
    setIsPending(true);
    try {
      const response = await fetch(`${weatherApi.baseUrl}/forecast/${buildKey}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error('Failed to fetch weather data');
      }
      const data = await response.json();
      setWeather(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsPending(false);
    }
  };

  return ( 
    <div className="flex h-screen">
      { error && <div className='flex flex-col flex-1 items-center justify-center'> { error } </div>}
      { isPending && <div className="m-auto align-middle justify-center text-center">
          <div className="loader mb-3 ml-1"></div>
          Loading...
        </div> 
      }
      { weather && <WeatherHome weather={weather} title={weather.resolvedAddress} />
      }
    </div>
  );
  
}

export default App;
